export class PaginationResponse<T> {
  public data: T[];
  public current_page: number;
  public last_page: number;
  public per_page: number;
  public path: string;
  public from: number;
  public to: number;
  public total: number;
  constructor(
    data: Array<T> = [],
    current_page = 1,
    last_page = 1,
    per_page = 100,
    path = "",
    from = 1,
    to = 1,
    total = 0
  ) {
    this.data = data;
    this.current_page = current_page;
    this.last_page = last_page;
    this.per_page = per_page;
    this.path = path;
    this.from = from;
    this.to = to;
    this.total = total;
  }
}
